// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-stretch: normal;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsiH0C4n.ttf) format('truetype');
}
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-stretch: normal;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0C4n.ttf) format('truetype');
}
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-stretch: normal;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsgH1y4n.ttf) format('truetype');
}
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-stretch: normal;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsg-1y4n.ttf) format('truetype');
}
.table {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.product-layout {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  border-radius: 10px;
  background: #414855;
  height: 350px;
  width: 450px;
  /* 16 dp */
  box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.1), 0px 6px 30px 0px rgba(0, 0, 0, 0.06), 0px 16px 24px 0px rgba(0, 0, 0, 0.07);
  border: 1px solid #414855;
  transition: border-color 0.3s;
  padding: 10px 10px 10px 10px;
  /* @media screen and (min-width: 1800px) {

      margin-left: 100px; 
     margin-right: 100px; 
      
    }
    @media screen and (min-width: 1400px) {

      margin-left: 30px;
      margin-right: 30px;
     
   }*/
}
.product-layout:hover {
  border-color: #0aea7f;
}
@media screen and (min-width: 768px) {
  .product-layout {
    width: auto;
  }
}
/* if logged in and footer is removed, expands the cards */
@media screen and (min-width: 768px) {
  .product-layout-logged {
    height: 350px;
  }
}
@media screen and (min-width: 1400px) {
  .product-layout-logged {
    height: 350px;
  }
}
@media screen and (min-width: 1800px) {
  .product-layout-logged {
    height: 35vh;
    min-height: 350px;
  }
}
.eyebrow-text {
  color: #ccc;
  /* H4 */
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0 0 0 0;
  padding: 20px 0 0 0;
}
.h2 {
  width: 493px;
  /* H2 */
  font-family: 'Open Sans', sans-serif;
  font-size: 26px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0 10 0 0;
}
.h2-proposal-submission {
  background: linear-gradient(90deg, #ff986c 2.42%, #ff756c 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.h2-lims {
  background: linear-gradient(90deg, #fff170 0%, #ff986c 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.h2-data {
  background: linear-gradient(90deg, #9dff70 0%, #fff170 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.h2-workbench {
  background: linear-gradient(60deg, #6aefdb 19.89%, #9dff70 82.98%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.h2-insight-engine {
  background: linear-gradient(90deg, #6cffc8 4.08%, #66d1ff 95.54%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.h2-circles {
  background: linear-gradient(90deg, #bc93ff 4.08%, #6ca7ff 95.54%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.p {
  color: #ccc;
  /* Bold Paragraph Text */
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  /* 24px */
  height: 80px;
}
.product-description-img {
  display: flex;
  padding: 8.5px;
  align-items: flex-start;
  gap: 8px;
  border-radius: 10px;
  border: 2px solid #ff986c;
  background: rgba(65, 72, 85, 0.8);
}
.lims {
  border: 2px solid #fff170;
}
.data {
  border: 2px solid #9dff70;
}
.workbench {
  border: 2px solid #9dff70;
}
.insight-engine {
  border: 2px solid #6aefdb;
}
.circles {
  border: 2px solid #bc93ff;
}
.product-img-border {
  display: flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
}
.product-img {
  width: 27px;
  height: 27px;
  flex-shrink: 0;
}
.typography {
  color: #ccc;
  /* Button Text */
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.8px;
  margin-top: 0;
  padding: 10px 0 0 0;
}
.product-section {
  background: #323640;
  border-bottom: 1px solid #5e6786;
  overflow-x: auto;
}
.loggedout-product-section {
  padding: 40px;
}
.product-section .ant-col {
  pointer-events: none;
}
.clickable * {
  pointer-events: auto;
}
.product-brief-intro {
  margin: 0 auto;
  display: flex;
  height: 750px;
  padding: 0px;
  padding-top: 0px;
  overflow: hidden;
  flex-direction: column;
  align-items: flex-start;
  background: #323640;
}
@media screen and (min-width: 768px) {
  .product-brief-intro {
    height: auto;
    margin: 0 0px;
  }
}
@media screen and (min-width: 1400px) {
  .product-brief-intro {
    margin: 0 0px;
  }
}
@media screen and (min-width: 1800px) {
  .product-brief-intro {
    margin: 0 0px;
  }
}
.h1-scientia-platform {
  color: #ccc;
  /* H1 Bold */
  font-family: 'Open Sans', sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.product-table {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.fullvh {
  height: calc(100vh - 80px);
}
.main-padding {
  margin: 0 40px;
  padding-bottom: 20px;
}
.crumbs-main {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
}
.title-wrapper-main {
  padding-top: 30px;
  padding-left: 20px;
}
`, "",{"version":3,"sources":["https:/fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap","webpack://./src/components/ScientiaProducts.less"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kIAAA;ACCF;ADCA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kIAAA;ACCF;ADCA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kIAAA;ACCF;ADCA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kIAAA;ACCF;AA5BA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AA8BF;AA3BA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EA6BA,UAAU;EA3BV,4HAAA;EAEA,yBAAA;EACA,6BAAA;EACA,4BAAA;EA4BA;;;;;;;;;;;KAWG;AACL;AAtCI;EACE,qBAAA;AAwCN;AA1BI;EAAA;IACE,WAAA;EA6BJ;AACF;AACA,0DAA0D;AAzBxD;EAAA;IACE,aAAA;EA4BF;AACF;AA1BE;EAAA;IACE,aAAA;EA6BF;AACF;AA3BE;EAAA;IACE,YAAA;IACA,iBAAA;EA8BF;AACF;AA3BA;EACE,WAAA;EA6BA,OAAO;EA3BP,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AA6BF;AA1BA;EACE,YAAA;EA4BA,OAAO;EA1BP,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AA4BF;AAzBA;EACE,+DAAA;EAKA,qBAAA;EACA,6BAAA;EACA,oCAAA;AAuBF;AApBA;EACE,4DAAA;EAKA,qBAAA;EACA,6BAAA;EACA,oCAAA;AAkBF;AAfA;EACE,4DAAA;EAKA,qBAAA;EACA,6BAAA;EACA,oCAAA;AAaF;AAVA;EACE,kEAAA;EAKA,qBAAA;EACA,6BAAA;EACA,oCAAA;AAQF;AALA;EACE,iEAAA;EAKA,qBAAA;EACA,6BAAA;EACA,oCAAA;AAGF;AAAA;EACE,iEAAA;EAMA,qBAAA;EACA,6BAAA;EACA,oCAAA;AAHF;AAMA;EACE,WAAA;EAJA,wBAAwB;EAMxB,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAJA,SAAS;EAKT,YAAA;AAHF;AAOA;EACE,aAAA;EACA,cAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,iCAAA;AALF;AAQA;EACE,yBAAA;AANF;AAQA;EACE,yBAAA;AANF;AAQA;EACE,yBAAA;AANF;AAQA;EACE,yBAAA;AANF;AAQA;EACE,yBAAA;AANF;AASA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AAPF;AASA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAPF;AAUA;EACE,WAAA;EARA,gBAAgB;EAUhB,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AARF;AAWA;EACE,mBAAA;EACA,gCAAA;EACA,gBAAA;AATF;AAYA;EACE,aAAA;AAVF;AAaA;EACE,oBAAA;AAXF;AAcA;EACE,oBAAA;AAZF;AAeA;EAEE,cAAA;EAEA,aAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EAEA,mBAAA;AAhBF;AAiBE;EAAA;IACE,YAAA;IACA,aAAA;EAdF;AACF;AAeE;EAAA;IACE,aAAA;EAZF;AACF;AAaC;EAAA;IACC,aAAA;EAVA;AACF;AAcA;EACE,WAAA;EAZA,YAAY;EAeZ,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAbF;AAeA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAbF;AAgBA;EACE,0BAAA;AAdF;AAiBA;EACE,cAAA;EACA,oBAAA;AAfF;AAkBA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AAhBF;AAmBA;EACE,iBAAA;EACA,kBAAA;AAjBF","sourcesContent":["@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 300;\n  font-stretch: normal;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsiH0C4n.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  font-stretch: normal;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0C4n.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 600;\n  font-stretch: normal;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsgH1y4n.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 700;\n  font-stretch: normal;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsg-1y4n.ttf) format('truetype');\n}\n","@import \"../styles/scientia-colors.less\";\n@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap');\n\n.table {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.product-layout {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  border-radius: 10px;\n  background: @scientia-grey;\n  height: 350px;\n  width: 450px;\n  /* 16 dp */\n  box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.1),\n    0px 6px 30px 0px rgba(0, 0, 0, 0.06), 0px 16px 24px 0px rgba(0, 0, 0, 0.07);\n  border: 1px solid @scientia-grey;\n  transition: border-color 0.3s;\n  padding: 10px 10px 10px 10px;\n  \n    &:hover {\n      border-color: @scientia-active-green;\n    }\n   /* @media screen and (min-width: 1800px) {\n\n      margin-left: 100px; \n     margin-right: 100px; \n      \n    }\n    @media screen and (min-width: 1400px) {\n\n      margin-left: 30px;\n      margin-right: 30px;\n     \n   }*/\n    @media screen and (min-width: 768px) {\n      width: auto;\n   }\n}\n\n/* if logged in and footer is removed, expands the cards */\n.product-layout-logged {\n  @media screen and (min-width: 768px) {\n    height: 350px;\n  }\n\n  @media screen and (min-width: 1400px) {\n    height: 350px;\n  }\n\n  @media screen and (min-width: 1800px) {\n    height: 35vh;\n    min-height: 350px;\n  }\n}\n\n.eyebrow-text {\n  color: @grey;\n  /* H4 */\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin: 0 0 0 0;\n  padding: 20px 0 0 0;\n}\n\n.h2 {\n  width: 493px;\n  /* H2 */\n  font-family: 'Open Sans', sans-serif;\n  font-size: 26px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin: 0 10 0 0;\n}\n\n.h2-proposal-submission {\n  background: linear-gradient(\n    90deg,\n    @scientia-orange 2.42%,\n    @scientia-red 100%\n  );\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.h2-lims {\n  background: linear-gradient(\n    90deg,\n    @scientia-yellow 0%,\n    @scientia-orange 100%\n  );\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.h2-data {\n  background: linear-gradient(\n    90deg,\n    @scientia-bright-green 0%,\n    @scientia-yellow 100%\n  );\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.h2-workbench {\n  background: linear-gradient(\n    60deg,\n    @scientia-bright-blue 19.89%,\n    @scientia-bright-green 82.98%\n  );\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.h2-insight-engine {\n  background: linear-gradient(\n    90deg,\n    @scientia-green 4.08%,\n    @scientia-blue 95.54%\n  );\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.h2-circles {\n  background: linear-gradient(\n    90deg,\n    @scientia-purple 4.08%,\n    @scientia-sky-blue 95.54%\n  );\n\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.p {\n  color: @grey;\n  /* Bold Paragraph Text */\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 24px */\n  height: 80px;\n  //padding: 15px\n}\n\n.product-description-img {\n  display: flex;\n  padding: 8.5px;\n  align-items: flex-start;\n  gap: 8px;\n  border-radius: 10px;\n  border: 2px solid @scientia-orange;\n  background: rgba(65, 72, 85, 0.8);\n}\n\n.lims {\n  border: 2px solid @scientia-yellow;\n}\n.data {\n  border: 2px solid #9dff70;\n}\n.workbench {\n  border: 2px solid #9dff70;\n}\n.insight-engine {\n  border: 2px solid #6aefdb;\n}\n.circles {\n  border: 2px solid #bc93ff;\n}\n\n.product-img-border {\n  display: flex;\n  width: 20px;\n  height: 20px;\n  justify-content: center;\n  align-items: center;\n}\n.product-img {\n  width: 27px;\n  height: 27px;\n  flex-shrink: 0;\n}\n\n.typography {\n  color: @grey;\n  /* Button Text */\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.8px;\n  margin-top: 0;\n  padding: 10px 0 0 0;\n}\n\n.product-section {\n  background: @background-grey;\n  border-bottom: 1px solid @grey-blue;\n  overflow-x: auto;\n}\n\n.loggedout-product-section {\n  padding: 40px;\n}\n\n.product-section .ant-col {\n  pointer-events: none;\n}\n\n.clickable * {\n  pointer-events: auto;\n}\n\n.product-brief-intro {\n // max-width: 1400px;\n  margin: 0 auto;\n  //margin: 0 100px;\n  display: flex;\n  height: 750px;\n  padding: 0px;\n  padding-top: 0px;\n  overflow: hidden;\n  flex-direction: column;\n  align-items: flex-start;\n\n  background: @background-grey;\n  @media screen and (min-width: 768px) {\n    height: auto;\n    margin: 0 0px;\n  }\n  @media screen and (min-width: 1400px) {\n    margin: 0 0px;\n }\n @media screen and (min-width: 1800px) {\n  margin: 0 0px;\n}\n\n}\n\n.h1-scientia-platform {\n  color: @grey;\n\n  /* H1 Bold */\n  font-family: 'Open Sans', sans-serif;\n  font-size: 40px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.product-table {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.fullvh {\n  height: calc(100vh - 80px);\n}\n\n.main-padding {\n  margin: 0 40px;\n  padding-bottom: 20px;\n}\n\n.crumbs-main {\n  color: #fff;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.title-wrapper-main {\n  padding-top: 30px;\n  padding-left: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
